/** Бэк редиректит с hash (#/path) — нормализуем до обычного пути до инициализации роутера */
export const handleHashRedirect = () => {
  const { hash } = window.location;

  if (hash.startsWith('#/')) {
    window.history.replaceState(null, '', hash.slice(1));
  }
};
